import { ReactElement, ReactNode, useState } from "react";
import { Box } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { BasicPageLayout } from "../../templates/BasicPageLayout";
import { SimpleAlertDialog } from "../../atoms/SimpleAlertDialog";
import { useModifiedTranslation } from "../../../hooks/useModifiedTranslation";

/*
 * 読み上げ文設定画面の枠。保存していない変更があれば、戻る前に確認する
 */
export function PhraseSettingLayout(
  props: Readonly<{
    title: string;
    hasUnsavedChanges?: () => boolean;
    children: ReactNode;
  }>,
): ReactElement {
  const { title, hasUnsavedChanges, children } = props;
  const t = useModifiedTranslation();
  const navigate = useNavigate();
  const [isConfirmingBack, setIsConfirmingBack] = useState(false);

  const onBack = (): void => {
    if (hasUnsavedChanges?.()) {
      setIsConfirmingBack(true);
      return;
    }
    navigate(-1);
  };

  return (
    <BasicPageLayout
      title={title}
      titleProps={{ fontSize: "2xl" }}
      showBackButton
      onBack={onBack}
      h="full"
    >
      <Box
        overflowY="auto"
        pb={6}
        sx={{
          scrollbarWidth: "thin",
          "&::-webkit-scrollbar": { width: "4px" },
          "&::-webkit-scrollbar-thumb": {
            bg: "chakra-border-color",
            borderRadius: "full",
          },
        }}
      >
        {children}
      </Box>
      <SimpleAlertDialog
        isOpen={isConfirmingBack}
        okTestId="phrase-setting-back-confirm"
        ok={t("Modal.yes")}
        cancel={t("Modal.no")}
        description={t("PhraseSetting.confirmBack")}
        onOk={() => {
          setIsConfirmingBack(false);
          navigate(-1);
        }}
        onClose={() => setIsConfirmingBack(false)}
      />
    </BasicPageLayout>
  );
}
